import * as React from "react";
import { forwardRef } from "react";
const ChevronLeftIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.478 4.453c.29.29.29.77 0 1.06l-6.97 6.97 6.97 6.97c.29.29.29.77 0 1.06s-.77.29-1.06 0l-7.5-7.5a.754.754 0 0 1 0-1.06l7.5-7.5c.29-.29.77-.29 1.06 0z"
}));
const ForwardRef = forwardRef(ChevronLeftIcon);
export default ForwardRef;